/**
 * Servicio que se encarga del manejo de las peticiones sobre las
 * acciones "Crear, Modificar y Eliminar" de los componentes.
 * CAAA-2018-12-06
 */
import { Injectable } from '@angular/core';
//Enrutamientos
import { Http, Response } from '@angular/http';
//Servicios
import { ConfigService } from '../../servicios/config/config.service';
//key
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class VersionequipoService {

  public equipos : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  ngOnInit() {}

  /**
   * Obtener Tipo Versionequipo
   * CAAA-2018-12-06
   */
   getTipoVersionequipo()
   {
     let url = this.PATH + '/api/admin/versionequipo';
     return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
   }// .getTipoVersionequipo()

   /**
    * Obtener un registro por id de un equipo para editar
    * CAAA-2018-12-06
    */
   getRegVersionequipo(id:any)
   {
     let url = this.PATH + '/api/admin/versionequipo/'+id+'/edit';
     return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
   }// .getRegMarca()

   /**
    * Enviar componente
    * JMM-2018-05-03
    */
   setTipoVersionequipo(componente:any)
   {
     let url = this.PATH + '/api/admin/versionequipo';
     return this.http.post(url, componente, {headers:this._key.head()}).map(resp => resp.json());
   }// .setEquipo(equipo:any)



   /**
    * Editar componente
    * CAAA-2018-12-06
    */
   editTipoVersionequipo(componente:any)
   {
     let url = this.PATH+'/api/admin/versionequipo/'+componente.id;
     return this.http.put(url,componente, {headers:this._key.head()}).map( resp => resp.json());
   }// .editTipoVersionequipo(equipo:any)

   /**
    * Eliminar componente
    * CAAA-2018-12-11
    */
   destroyTipoVersionequipo(id:any)
   {
     let url = this.PATH + '/api/admin/versionequipo/'+id+'/destroy';
     return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
   }// .destroyTipoVersionequipo(id:any)

   getFiltrosVersionequipo(inform){
     {
      let url = this.PATH + '/api/admin/versionequipofiltros';
      return this.http.post(url, inform ,{headers:this._key.head()}).map(resp => resp.json());
     }
   }

  updateCreateVersion(inform){
     let url = this.PATH + '/api/admin/updateCreateVersion';
     return this.http.post(url, inform ,{headers:this._key.head()}).map(resp => resp.json());
  }

  getVersiones(versionequipoid:any)
  {
    let url = this.PATH+'/api/admin/getVersiones/'+versionequipoid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  destroyVersion(versionid:any){
    let url = this.PATH+'/api/admin/destroyVersion/'+versionid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  getVersionEquipo(equipoid:any){
    let url = this.PATH+'/api/admin/getVersionEquipo/'+equipoid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  getversiondisponible(itemequipoid:any){
    let url = this.PATH+'/api/admin/getversiondisponible/'+itemequipoid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  getEquipoVersionNoCreadas(){
    let url = this.PATH+'/api/admin/getEquipoVersionNoCreadas';
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/versiones/versiones.service.ts